import { Link } from 'react-router-dom';

export default function Footer() {
  const categoryLinks = [
    { slug: 'pop', name: '流行MV' },
    { slug: 'rock', name: '摇滚MV' },
    { slug: 'hiphop', name: '嘻哈MV' },
    { slug: 'electronic', name: '电子MV' },
    { slug: 'rnb', name: '节奏蓝调MV' },
    { slug: 'latin', name: '拉丁MV' },
  ];

  const quickLinks = [
    { path: '/', name: '首页' },
    { path: '/about', name: '关于我们' },
  ];

  return (
    <footer className="bg-foreground-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-mv-line text-xl text-white"></i>
                </div>
                <span className="font-heading text-xl font-bold text-foreground-50 whitespace-nowrap">
                  欧美MV大全
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                汇聚全球最新最热欧美MV，涵盖流行、摇滚、嘻哈、电子等多种风格。在线免费观看高清欧美音乐视频，第一时间追踪Billboard榜单热门欧美MV。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">
                <a href="#category-section" className="hover:text-primary-400 transition-colors">MV分类</a>
              </h4>
              <div className="grid grid-cols-2 gap-2">
                {categoryLinks.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2">
                {quickLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 欧美MV大全. 本站内容仅供学习交流使用.
            </p>
            <p className="text-xs text-foreground-500">
              Billboard、MTV等相关商标归各自权利人所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}